import "./style.css";
import { CmsBlocksDataState } from "../../utils/interfaces/cmsBlock";

interface HelperCardProps {
  data: CmsBlocksDataState;
}

const HelperCard = (props: HelperCardProps) => {
  let htmlContent = "";
  if (props.data && props.data?.items && props.data?.items.length > 0)
    htmlContent = props.data?.items[0]?.content;
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const extractedText = doc.body.textContent || "";

  return (
    <section className="nexis-container !pt-20 !pb-12 !bg-white ">
      <div className="flex items-center flex-col">
        <div dangerouslySetInnerHTML={{ __html: extractedText }} />
      </div>
    </section>
  );
};

export default HelperCard;
